module.exports = __webpack_public_path__ + "img/fc2.0518260a.png";